import { API_HOST, STORAGE_KEY } from "@/lib/config"

const API_BASE = `${API_HOST}/api/v1/xiaohua`

function getAuthHeaders(): HeadersInit {
  const headers: HeadersInit = {}
  const token = localStorage.getItem(STORAGE_KEY)
  if (token) {
    ;(headers as Record<string, string>).Authorization = `Bearer ${token}`
  }
  return headers
}

async function handleResponse<T>(response: Response): Promise<T> {
  if (response.status === 401) {
    localStorage.removeItem(STORAGE_KEY)
    window.location.hash = "#/login"
    throw new Error("会话已过期，请重新登录")
  }
  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}))
    throw new Error(errorData.detail || "请求失败")
  }
  return response.json()
}

export interface XiaoHuaSolveRequest {
  content: string
  image_url?: string
  question_id?: string
}

export interface SVGStep {
  step_id: string
  title: string
  svg: string
  speak_text: string
  display_markdown: string
}

export interface XiaoHuaSolveResponse {
  problem_id: string
  problem_stem: string
  steps: SVGStep[]
  final_answer: string
  summary_markdown: string
}

export async function solveXiaoHua(
  data: XiaoHuaSolveRequest,
): Promise<XiaoHuaSolveResponse> {
  const response = await fetch(`${API_BASE}/solve`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getAuthHeaders(),
    },
    body: JSON.stringify(data),
  })
  return handleResponse(response)
}
